export const ENUM_LIST = 'ENUM_LIST'
export const CHANGE_ASSIGN = 'CHANGE_ASSIGN'
    